import * as React from 'react';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import { UserSession } from '../../models/UserSession';
import { Avatar } from 'primereact/avatar';
import { Grid } from '@mui/material';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useApiService from '../../hooks/useApiService';
import { PPEImportAPI } from '../../service/ppeService';



export default function PPEImport(modalProps: any) {

  const session: UserSession = modalProps.session;

  const { data, loading, error } = useApiService<any[]>({
      method: "GET",
      url: "ppe-import",
      apiName: "core",
      params: {
        clientId: session.client_id,
        siteId: session.site_id,
      },
    });

  async function Add() {
    console.log("records == ", records);
    modalProps.setGlobalLoading(true);
    let ids = records.map((e: any) => e.id);

    PPEImportAPI({ import: ids }).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Added Successfully', life: 3000 });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    }).catch((error) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'error', summary: 'Failed to create Equipment', life: 3000 });
      modalProps.setVisible(false);
      console.log("error == ", error);
    });

  }

  const [records, setRecords] = React.useState([]);

  const imageBodyTemplate = (item: any) => {
    return <Avatar image={item.photo} style={{ width: 30 }} />;
  };

  const renderHtml = (item: any) => {
    return<div dangerouslySetInnerHTML={{ __html: item.description }} style={{ width: 30 }}  />;
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="card">
            <DataTable value={data || []} tableStyle={{ width: '100%' }}
              columnResizeMode="expand" showGridlines size="small"
              selectionMode="checkbox"
              selection={records}
              onSelectionChange={(e) => setRecords(e.value as any)}
              dataKey="id"
            >
              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
              <Column header="Image" body={imageBodyTemplate}></Column>
              <Column field="name" header="Name"></Column>
              <Column header="description" body={renderHtml}></Column>
              <Column field="frequency" header="Frequency"></Column>
            </DataTable>
          </div>
        </Grid>
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-file-import" label="Import" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#1E1A34" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}